/**
 * Inserts extension guide feature images after blog h2 tool sections that link to known affiliates.
 */
(function () {
  var DOMAIN_HANDLES = [
    ['squarekicker.com', 'squarekicker'],
    ['elfsight.io', 'elfsight'],
    ['seospace.co', 'seospace'],
    ['shipbob.com', 'shipbob'],
    ['semrush.', 'semrush'],
    ['memberspace.com', 'memberspace'],
    ['typeform.', 'typeform'],
    ['weglot.com', 'weglot'],
    ['termly.', 'termly'],
    ['monocle-search.com', 'monocle-search'],
    ['livechat.com', 'livechat'],
    ['chatbot.com', 'chatbot'],
    ['jotform.com', 'jotform'],
    ['sparkplugin.com', 'spark'],
    ['accessibe.com', 'accessibe'],
    ['acuityscheduling.com', 'acuity'],
    ['booqable.com', 'booqable'],
    ['calendly.com', 'calendly'],
    ['getterms.io', 'getterms'],
    ['hellobar.com', 'hello-bar'],
    ['honeybook.com', 'honeybook'],
    ['kleemt.com', 'kleemt'],
    ['litextension.com', 'litextension'],
    ['lodgify.com', 'lodgify'],
    ['mailchimp.com', 'mailchimp'],
    ['printful.com', 'printful'],
    ['printify.com', 'printify'],
    ['privy.com', 'privy'],
    ['spocket.co', 'spocket'],
    ['tapfiliate.com', 'tapfiliate'],
    ['tawk.to', 'tawk-to'],
    ['termageddon.com', 'termageddon'],
    ['thrivecart.com', 'thrivecart'],
    ['tidio.com', 'tidio'],
    ['userway.org', 'userway'],
    ['ecwid.com', 'ecwid'],
    ['shopify.com/buy-button', 'shopify-buy-button'],
    ['eventually.io', 'eventually']
  ];

  var IMAGE_META = {
    accessibe: {
      alt: 'The accessiBe accessWidget accessibility menu open on a website',
      caption: 'Visitors open accessWidget to adjust contrast, text, and navigation, with profiles for different needs.'
    },
    acuity: {
      alt: 'The Acuity Scheduling client booking page',
      caption: 'Clients book appointments or classes themselves, with everything synced to your calendar.'
    },
    booqable: {
      alt: 'A Booqable rental store with date picker and availability',
      caption: 'Customers pick dates, see live availability and pricing, and book directly on your site.'
    },
    calendly: {
      alt: 'A Calendly booking page',
      caption: 'Visitors see your open slots and pick a time; both calendars update automatically.'
    },
    chatbot: {
      alt: 'ChatBot AI chatbot on a Squarespace site',
      caption: 'Build and deploy AI chatbots without code, trained on your content.'
    },
    elfsight: {
      alt: 'Elfsight TikTok feed widget',
      caption: 'Embed social feeds like TikTok in clean, branded layouts on your Squarespace site.'
    },
    eventually: {
      alt: 'Eventually waitlist and launch page on Squarespace',
      caption: 'Collect signups and build anticipation before your launch.'
    },
    getterms: {
      alt: 'GetTerms policy generator dashboard',
      caption: 'Generate privacy policies and terms tailored to your business.'
    },
    'hello-bar': {
      alt: 'Hello Bar notification bar on a website',
      caption: 'Capture leads and announce offers with a lightweight top bar.'
    },
    honeybook: {
      alt: 'HoneyBook client workflow dashboard',
      caption: 'Manage enquiries, proposals, contracts, and payments in one place.'
    },
    jotform: {
      alt: 'Jotform form builder interface',
      caption: 'Build flexible forms with payments, workflows, and integrations.'
    },
    kleemt: {
      alt: 'Kleemt membership and community platform',
      caption: 'Run memberships, courses, and communities on Squarespace.'
    },
    litextension: {
      alt: 'LitExtension migration dashboard',
      caption: 'Migrate store data to Squarespace with guided transfer tools.'
    },
    livechat: {
      alt: 'LiveChat widget on a Squarespace site',
      caption: 'Offer live chat and AI-assisted support from a polished widget.'
    },
    lodgify: [
      {
        alt: 'Lodgify property listing synced with Booking.com, Airbnb, Google, and Vrbo',
        caption: 'See which channels each rental is connected to, with sync status for every listing.'
      },
      {
        alt: 'Lodgify unified calendar with Airbnb, Vrbo, and Booking.com reservations',
        caption: 'Bookings from every channel appear on one calendar, with rates and cleaning tasks in view.'
      }
    ],
    mailchimp: {
      alt: 'Mailchimp email signup form embedded on a site',
      caption: 'Grow your list and send campaigns from a familiar email platform.'
    },
    memberspace: {
      alt: 'A MemberSpace membership community on Squarespace',
      caption: 'Run membership communities and gated content on your Squarespace site.'
    },
    'monocle-search': {
      alt: 'Monocle Search results for member-only content',
      caption: 'Monocle can search Member Site content that native Squarespace search cannot reach.'
    },
    printful: {
      alt: 'Printful branded merch and apparel product mockups',
      caption: 'Sell print-on-demand products without holding inventory.'
    },
    printify: {
      alt: 'Printify product catalog and mockup editor',
      caption: 'Connect to print providers and publish custom products quickly.'
    },
    privy: {
      alt: 'Privy popup and email capture on a storefront',
      caption: 'Capture emails and run onsite campaigns with popups and bars.'
    },
    semrush: {
      alt: 'Keyword research in Semrush showing search volume and difficulty',
      caption: 'Keyword research with search volume, difficulty and the questions people search.'
    },
    seospace: [
      {
        alt: 'SEOSpace all-in-one Squarespace SEO tool dashboard',
        caption: 'SEOSpace brings audits, keyword research, rank tracking, AI visibility, and local SEO into one Squarespace-focused dashboard.'
      },
      {
        alt: 'SEOSpace one-click SEO audit with prioritised tasks',
        caption: 'Run a one-click audit and get a prioritised list of critical, recommended, and optional fixes in plain language.'
      }
    ],
    shipbob: {
      alt: 'ShipBob outsourced fulfilment for Squarespace stores',
      caption: 'Store inventory, fulfil orders, and ship from ShipBob\'s global network.'
    },
    'shopify-buy-button': {
      alt: 'Shopify Buy Button embedded product on a page',
      caption: 'Embed individual products or a mini storefront on Squarespace.'
    },
    spark: {
      alt: 'Spark plugin suite inside Squarespace',
      caption: 'Add advanced layout and content blocks without custom code.'
    },
    spocket: {
      alt: 'Spocket dropshipping product catalog',
      caption: 'Source products and sync inventory for dropshipping stores.'
    },
    squarekicker: {
      alt: 'SquareKicker visual editor inside the Squarespace admin',
      caption: 'The design toolbar layers over Squarespace so you can style and animate without code.'
    },
    tapfiliate: {
      alt: 'Tapfiliate affiliate program dashboard',
      caption: 'Track referrals and manage affiliate commissions from one dashboard.'
    },
    'tawk-to': {
      alt: 'Tawk.to live chat widget on a website',
      caption: 'Free live chat with visitor monitoring and basic automation.'
    },
    termageddon: {
      alt: 'Termageddon auto-updating policies dashboard',
      caption: 'Policies that update automatically as privacy laws change.'
    },
    termly: {
      alt: 'Termly cookie policy generator and consent management tools',
      caption: 'Generate policies and manage cookie consent from one Termly dashboard.'
    },
    thrivecart: {
      alt: 'ThriveCart checkout and funnel builder',
      caption: 'Sell products and subscriptions with high-converting checkouts.'
    },
    tidio: {
      alt: 'Tidio live chat and chatbot on a site',
      caption: 'Combine live chat and AI bots in one lightweight widget.'
    },
    typeform: {
      alt: 'A Typeform conversational form',
      caption: 'One question at a time keeps people engaged and lifts completion rates.'
    },
    userway: {
      alt: 'UserWay accessibility widget open on a website',
      caption: 'Give visitors accessibility controls from a simple overlay.'
    },
    weglot: {
      alt: 'Editing a translation in the Weglot visual editor',
      caption: 'The visual editor lets you refine any machine translation in context.'
    },
    ecwid: {
      alt: 'Ecwid store embedded on a Squarespace page',
      caption: 'Run a full storefront with cart and checkout embedded on your site.'
    }
  };

  function getHandleFromHeading(heading) {
    var link = heading.querySelector('a[href]');
    if (!link) return null;

    var href = (link.getAttribute('href') || '').toLowerCase();
    if (!href) return null;

    for (var i = 0; i < DOMAIN_HANDLES.length; i++) {
      if (href.indexOf(DOMAIN_HANDLES[i][0]) !== -1) {
        return DOMAIN_HANDLES[i][1];
      }
    }

    return null;
  }

  function getImageMeta(handle, index) {
    var meta = IMAGE_META[handle];

    if (Array.isArray(meta)) {
      return meta[index] || meta[meta.length - 1] || {};
    }

    if (meta) return meta;

    return {};
  }

  function insertFigure(heading, imageMap, handleUsage) {
    var handle = getHandleFromHeading(heading);
    if (!handle || !imageMap[handle]) return;

    var next = heading.nextElementSibling;
    if (next && next.classList && next.classList.contains('article-extension-figure')) return;

    var images = imageMap[handle];
    if (!Array.isArray(images)) {
      images = [images];
    }

    var usageIndex = handleUsage[handle] || 0;
    handleUsage[handle] = usageIndex + 1;

    var imageSrc = images[Math.min(usageIndex, images.length - 1)];
    if (!imageSrc) return;

    var link = heading.querySelector('a[href]');
    var label = link && link.textContent ? link.textContent.replace(/\s+/g, ' ').trim() : handle;
    var meta = getImageMeta(handle, usageIndex);

    var figure = document.createElement('figure');
    figure.className = 'article-extension-figure extension-figure';
    figure.setAttribute('data-extension-handle', handle);
    figure.setAttribute('data-extension-slot', String(usageIndex + 1));

    var img = document.createElement('img');
    img.src = imageSrc;
    img.alt = meta.alt || label;
    img.loading = 'lazy';
    img.width = 1200;
    img.height = 675;

    figure.appendChild(img);

    if (meta.caption) {
      var caption = document.createElement('figcaption');
      caption.className = 'extension-figure__caption';
      caption.textContent = meta.caption;
      figure.appendChild(caption);
    }

    heading.insertAdjacentElement('afterend', figure);
  }

  function run() {
    var mapEl = document.getElementById('extension-image-map');
    if (!mapEl) return;

    var imageMap;
    try {
      imageMap = JSON.parse(mapEl.textContent);
    } catch (error) {
      return;
    }

    var rte = document.querySelector('.article-template .article-template-content__rte.rte');
    if (!rte) return;

    var handleUsage = {};

    rte.querySelectorAll('h2').forEach(function (heading) {
      insertFigure(heading, imageMap, handleUsage);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
